var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObligatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53728 12.3517L2.61106 7.42545L0 10.0365L6.23153 16.268C6.57815 16.6138 7.04762 16.8084 7.53728 16.8084C8.0265 16.8084 8.49598 16.6138 8.84258 16.268L20 5.11062L17.3889 2.5L7.53728 12.3517Z",
    fill: "#17C571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObligatory);
export default __webpack_public_path__ + "static/media/obligatory.9fa2bbe1b9405a3490d8e3a4638c1fee.svg";
export { ForwardRef as ReactComponent };